/**
 * CRM leads — table list view
 */

import React from 'react'
import { useNavigate } from 'react-router-dom'
import {
  DatatableCard,
  DatatableScroll,
  DATATABLE_CELL_CLASS,
  DATATABLE_CELL_PRIMARY_CLASS,
  DATATABLE_TABLE_CLASS,
  DATATABLE_TBODY_CLASS,
  DATATABLE_THEAD_CLASS,
} from '../../shared/Datatable'
import DatatablePagination from '../../shared/DatatablePagination'
import { formatDbDateTime } from '../../../utils/datetime'
import { LEAD_SOURCE_LABELS, LEAD_STATUS_LABELS, statusBadgeClass } from '../../../lib/crm-display'

export default function CrmLeadsList({ leads, pagination, refreshing }) {
  const navigate = useNavigate()

  return (
    <DatatableCard
      className={refreshing ? 'opacity-60 pointer-events-none' : ''}
      footer={<DatatablePagination {...pagination} itemLabel="cases" />}
    >
      <DatatableScroll>
        <table className={DATATABLE_TABLE_CLASS}>
          <thead className={DATATABLE_THEAD_CLASS}>
            <tr>
              <th className="p-3 text-left text-sm font-medium text-muted-foreground">Name</th>
              <th className="p-3 text-left text-sm font-medium text-muted-foreground">Status</th>
              <th className="p-3 text-left text-sm font-medium text-muted-foreground">Source</th>
              <th className="p-3 text-left text-sm font-medium text-muted-foreground">Assignee</th>
              <th className="p-3 text-left text-sm font-medium text-muted-foreground">Last activity</th>
              <th className="p-3 text-left text-sm font-medium text-muted-foreground">Idle</th>
            </tr>
          </thead>
          <tbody className={DATATABLE_TBODY_CLASS}>
            {leads.map((lead) => {
              const openLead = () => navigate(`/hub/crm/${lead.id}`)
              const rowClass = lead.is_idle
                ? 'bg-amber-50/60 hover:bg-amber-50'
                : 'hover:bg-gray-50/80'

              return (
                <tr key={lead.id} className={`cursor-pointer ${rowClass}`}>
                  <td className={DATATABLE_CELL_PRIMARY_CLASS} onClick={openLead}>
                    <span className="font-medium text-green-800">{lead.display_name}</span>
                  </td>
                  <td className={DATATABLE_CELL_CLASS} onClick={openLead}>
                    <span
                      className={`inline-flex px-2 py-0.5 rounded-full text-xs font-medium ${statusBadgeClass(lead.status)}`}
                    >
                      {LEAD_STATUS_LABELS[lead.status] || lead.status}
                    </span>
                  </td>
                  <td className={DATATABLE_CELL_CLASS} onClick={openLead}>
                    {LEAD_SOURCE_LABELS[lead.source] || lead.source}
                  </td>
                  <td className={DATATABLE_CELL_CLASS} onClick={openLead}>
                    {lead.assignee_name || <span className="text-gray-400">Unassigned</span>}
                  </td>
                  <td className={DATATABLE_CELL_CLASS} onClick={openLead}>
                    {formatDbDateTime(lead.last_activity_at)}
                  </td>
                  <td className={DATATABLE_CELL_CLASS} onClick={openLead}>
                    {lead.days_idle != null ? (
                      <span className={lead.is_idle ? 'font-semibold text-amber-800' : ''}>
                        {lead.days_idle}d
                      </span>
                    ) : (
                      '—'
                    )}
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </DatatableScroll>
    </DatatableCard>
  )
}
